export default __webpack_public_path__ + "static/close-44e8547c9c630559d62ca4646749adaa.png";